<div class="relative flex h-full flex-col gap-4">
  <button
    app-outline-button
    *ngIf="(dataViewer$ | async) || (loadingImg$ | async)"
    (click)="onToggleZoom()"
    class="text-full group !absolute right-0 z-10 flex h-12 w-12 justify-center rounded-full border-none bg-base-ea-400 hover:bg-base-ea-600 hover:font-semibold"
  >
    <app-skeleton *ngIf="loadingImg$ | async" class="w-6" baseStyle="bg-base-ea-400"></app-skeleton>
    <svg-icon
      *ngIf="isZoomedIn; else zoomOutTemplate"
      class="w-6 text-white group-hover:text-white"
      src="assets/icons/icon-zoom-out.svg"
    ></svg-icon>
    <ng-template #zoomOutTemplate>
      <svg-icon class="w-6 text-white group-hover:text-white" src="assets/icons/icon-zoom-in.svg"></svg-icon>
    </ng-template>
  </button>

  <app-card class="flex h-[55vh] w-full overflow-y-auto p-5 shadow-inner shadow-black/40 md:h-full md:max-h-[77vh]">
    <ng-container *ngIf="dataViewer$ | async as dataViewer; else emptyImage">
      <div class="flex h-full w-full justify-center !rounded-lg">
        <div class="h-full w-full">
          <pinch-zoom
            *ngIf="isImage; else pdfTemplate"
            #pinchZoom
            [zoomControlScale]="2"
            [autoHeight]="true"
            [wheel]="false"
          >
            <img [src]="dataViewer.url | safe : 'resourceUrl'" (load)="onLoadedImg()" />
          </pinch-zoom>
          <ng-template #pdfTemplate>
            <pdf-viewer
              [src]="dataViewer.url"
              [original-size]="false"
              [show-all]="false"
              [page]="dataViewer.page"
              [fit-to-page]="false"
              [zoom]="zoom$ | async"
              [zoom-scale]="'page-width'"
              [stick-to-page]="false"
              [render-text]="true"
              [external-link-target]="'blank'"
              [autoresize]="true"
              [show-borders]="false"
              class="h-full w-full"
              (after-load-complete)="onLoadedImg()"
            ></pdf-viewer>
          </ng-template>
        </div>
      </div>
    </ng-container>
    <ng-template #emptyImage>
      <div class="grid h-auto gap-4">
        <app-card>
          <div app-card-content class="h-[40rem] w-full">
            <app-jumbotron [showIcon]="false" translate>
              <svg-icon class="mb-5 w-20 text-gray-300" src="assets/icons/icon-improvement.svg"></svg-icon>
              gestor-avaliacoes.sem-imagem
            </app-jumbotron>
          </div>
        </app-card>
      </div>
    </ng-template>
  </app-card>
</div>
